export function activeOnScroll() {
    let $sections = $(".faqs-results");
    $(window).on("scroll", function () {
        
        $sections.each(function (i, el) {

            let top = $(el).offset().top - 140;
            let bottom = top + $(el).height() ;
            let scroll = $(window).scrollTop();
            let id = $(el).attr("id");

            if (scroll > top && scroll < bottom) {
                $("aside a.active").removeClass("active");
                $("a[href=\"#" + id + "\"]").addClass("active");
            }
            
        });
    
    });
    let header = $(".header");
    $(".faqs-nav").on("click", 'a[href^="#"]', function (event) {
        event.preventDefault();
        let scrollTop = $($.attr(this, "href")).offset().top;
        $("html, body").animate({
            scrollTop: scrollTop - header.innerHeight()
        }, 500);
    });
}



// WEBPACK FOOTER //
// ./assets/js/modules/scrollActive.js